document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('video-player-container');
  const overlay = document.getElementById('video-player-overlay');
  const btnClose = document.getElementById('video-player-close');

  const potentials = document.querySelectorAll('[class*=vimeo-]');
  [...potentials].forEach((element) => {
    element.addEventListener('click', () => {
      element.classList.forEach((name) => {
        if (name.startsWith('vimeo-')) {
          const arr = name.split('-');
          if (arr.length === 2) setVideo(arr[1]);
        }
      });
    });
  });

  [btnClose, overlay].forEach((element) => {
    element.addEventListener('click', () => {
      overlay.style.display = 'none';
      container.innerHTML = '';
    });
  });

  const embedVideo = document.getElementById('embed-vimeo');
  if (embedVideo) {
    var played = false;
    document.addEventListener(
      'scroll',
      function () {
        if (isElementInViewport(embedVideo)) {
          played = true;
          embedVideo.play();
        }
      },
      true
    );

    if (isElementInViewport(embedVideo)) {
      played = true;
      embedVideo.play();
    }
  }
});

function isElementInViewport(el) {
  if (typeof jQuery === 'function' && el instanceof jQuery) {
    el = el[0];
  }
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function setVideo(vimeoID) {
  if (typeof ga != 'undefined') {
    ga('create', 'UA-80475308-1', 'auto');
    ga('send', 'event', {
      eventCategory: 'Vimeo',
      eventAction: 'click',
      eventLabel: 'https://vimeo.com/' + vimeoID,
    });
  }

  const overlay = document.getElementById('video-player-overlay');
  const container = document.getElementById('video-player-container');
  const embed = `<iframe src="https://player.vimeo.com/video/${vimeoID}?autoplay=1" frameborder="0" allow="autoplay; fullscreen"></iframe>`;

  container.innerHTML = embed;

  resizeVideo();
  overlay.style.display = 'flex';

  const iframe = container.querySelector('iframe');
  iframe.addEventListener('click', (e) => {});

  window.addEventListener('resize', resizeVideo);
}

function resizeVideo() {
  const w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  const maxWidth = 1060;

  const container = document.getElementById('video-player-container');

  const iframe = container.querySelector('iframe');

  let newWidth = w;
  if (newWidth > maxWidth) newWidth = maxWidth;

  iframe.style.width = `${newWidth - 24}px`;
  iframe.style.height = `${(newWidth - 24) / 1.777}px`;
}
